export default {"src":"/_next/static/media/ic-error.42ebf03e.svg","height":155,"width":155};